<template>
  <modal
  name="start-broadcasting-modal"
  height="auto"
  :pivot-y="0.3"
  :adaptive="true"
  :width="428">
    <div class="StartBroadcasting__wrapper">
      <div class="StartBroadcasting__header">
        <i class="StartBroadcasting__broadcast-icon icon-ic_broadcast"></i>
      </div>
      <div class="StartBroadcasting__container">
        <div class="Grid-row">
          <div class="StartBroadcasting__title">
            Enter RSTP Link
          </div>
        </div>
        <div class="Grid-row">
          <div class="form-label">
            RSTP LINK
          </div>
          <input
            v-focus
            type="text"
            name="url"
            placeholder="http://"
            v-model="url"
            class="field"
            :class="{'is-danger': errors.has('url')}"
            v-validate="'required'"
            data-vv-delay="500"
            data-vv-as="RSTP LINK"
            ref="url"
            @keyup.enter="submit"
            required>
          <span v-show="errors.has('url')"
                class="form-help is-danger">
            {{ errors.first('url') }}
          </span>
        </div>
        <div class="Grid-row">
          <div class="form-actions pull-right">
            <a @click="$modal.hide('start-broadcasting-modal')"
               class="cancel-btn">cancel</a>
            <a @click="submit"
               class="submit-btn">start</a>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'StartBroadcasting',
    data() {
      return {
        url: null
      };
    },
    methods: {
      submit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$store.dispatch('startBroadcast', this.url);
          } else {
            this.$refs.url.focus();
          }
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// start-broadcasting.modal.vue?58b69546